import { compiledClientConfig } from "config";
import { getCurrentVersion } from "utils/version";
import type { CompanyModel } from "models/CompanyModel";
import type { UserModel } from "models/UserModel";

let gainsightInitialized = false;

export type TLoginDetails = {
	method: "oidc" | "saml";
	provider: "google" | "microsoft" | "okta";
};

export const gainsightInit = async () => {
	const clientId = compiledClientConfig.gainsightClientId;
	if (clientId) {
		if (typeof window.aptrinsic !== "function") return;

		window.aptrinsic("init", clientId, {});
		gainsightInitialized = true;

		// Send custom version/env event
		const version = await getCurrentVersion();
		const environment = compiledClientConfig.appEnv;

		window.aptrinsic("track", "App Loaded", { version, environment });
		gainsightInitialized = true;
	}
};

export const setGainsightUserScope = (
	user: UserModel,
	company: CompanyModel,
	loginDetails?: { method: "oidc" | "saml"; provider: "google" | "microsoft" | "okta" }
) => {
	if (!gainsightInitialized || !user) return;
	const loginMethod = loginDetails ? `${loginDetails.method} (${loginDetails.provider})` : undefined;

	window.aptrinsic(
		"identify",
		{
			id: user.id,
			email: user.email,
			firstName: user.givenName,
			lastName: user.familyName,
			signUpDate: new Date().toISOString(),
			role: user.role
		},
		{ id: company.id, name: company.name, loginMethod }
	);

	if (loginMethod) {
		gainsightLog("User Login", { loginMethod });
	}
};

export const gainsightLog = (message: string, extra?: Record<string, unknown>) => {
	if (!gainsightInitialized) return;
	window.aptrinsic("track", message, extra);
};

export const gainsightLogError = (error: Error, extra?: Record<string, unknown>) => {
	if (!gainsightInitialized) return;
	window.aptrinsic("track", "Client Error", {
		message: error.message,
		stack: error.stack,
		...extra
	});
};
